"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Button_1 = require("@Components/Buttons/Button");
const ConfirmationStep = (props) => {
    const { createWork, closeSidebar, isInternal, disableButton } = props;
    return (react_1.default.createElement("div", { className: "warning-edit-work-popup" },
        react_1.default.createElement("h3", null, "Confirm Submission"),
        react_1.default.createElement("p", null,
            "Click ",
            react_1.default.createElement("strong", null, "Submit"),
            " to submit this work to The MLC.",
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            "To review or edit any information, click ",
            react_1.default.createElement("strong", null, "Back"),
            "."),
        react_1.default.createElement("div", { className: "links-block" },
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary', onClick: closeSidebar }, "Back"),
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', disabled: disableButton || isInternal, onClick: createWork }, "Submit"))));
};
exports.default = ConfirmationStep;
